import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { useEffect } from "react";
import { useAppSelector } from "../../redux";
import { selectText } from "../LanguageSelect/LanguageSelectSlice";
import { Grid } from "@mui/material";
import { useStyles } from "./ModalHooks";
import { EmailModal } from "./EmailModal/EmailModal";
import { PhoneModal } from "./PhoneModal/PhoneModal";
import { AddressModal } from "./AddressModal/AddressModal";
import { WarningModal } from "./WarningModal";
import type { User } from "../../types";
import { ClaimsTypes } from "../Queue/ClaimsTypes";
import { SkipCaseModal } from "../Queue/SkipCaseModal";
import { ReasonsModal } from "../Queue/ReasonsModal";
import { selectClaimsTypes } from "../Queue/QueueSlice";

interface CustomModalProps {
  modal: boolean;
  handleClose(): void;
  type: string | null;
  user?: User | null;
}
export function CustomModal(props: CustomModalProps) {
  const { modal, handleClose, type, user } = props;
  const { modalStyle } = useStyles();

  const text = useAppSelector(selectText);
  const types = useAppSelector(selectClaimsTypes);

  useEffect(() => {
    if (!type) {
      handleClose();
    }
  }, [type]);

  const renderFields = (type: string | null) => {
    switch (type) {
      case "email": {
        return <EmailModal handleClose={handleClose} />;
      }
      case "phone": {
        return <PhoneModal handleClose={handleClose} />;
      }
      case "address": {
        return <AddressModal handleClose={handleClose} />;
      }
      case "warning": {
        return <WarningModal user={user as User} handleClose={handleClose} />;
      }
      case "queue": {
        return <ClaimsTypes handleClose={handleClose} />;
      }
      case "skip_case": {
        return <SkipCaseModal handleClose={handleClose} />;
      }
      case "decision": {
        return <ReasonsModal handleClose={handleClose} />;
      }
      default: {
        <Typography>"nothig to render"</Typography>;
      }
    }
  };

  const renderTitle = (type: string | null) => {
    switch (type) {
      case "decision": {
        return (
          <Typography variant="h3" textAlign={"center"}>
            Please select a reason
          </Typography>
        );
      }
      case "email": {
        return (
          <Typography variant="h3" textAlign={"center"}>
            {text.formsFeilds.email}
          </Typography>
        );
      }
      case "phone": {
        return (
          <Typography variant="h3" textAlign={"center"}>
            {text.formsFeilds.phone}
          </Typography>
        );
      }
      case "address": {
        return (
          <Typography variant="h3" textAlign={"center"}>
            {text.formsFeilds.addressTitle}
          </Typography>
        );
      }
      case "warning": {
        return (
          <Typography color={"red"} variant="h3" textAlign={"center"}>
            WARNING!{" "}
          </Typography>
        );
      }
      case "queue": {
        if (types && types.length) {
          return (
            <Typography variant="h3" textAlign={"center"}>
              Please select a claims type
            </Typography>
          );
        } else {
          return null;
        }
      }
      case "skip_case": {
        return (
          <Typography variant="h3" textAlign={"center"}>
            Confirm case skip{" "}
          </Typography>
        );
      }
    }
  };

  return (
    <Modal
      open={modal}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{}}
    >
      <Grid sx={modalStyle} container spacing={3} direction="row" justifyContent="flex-start" alignItems="center">
        <Grid item xs={12} xl={12}>
          {renderTitle(type)}
        </Grid>
        <Grid item xs={12} xl={12}>
          {renderFields(type)}
        </Grid>
      </Grid>
    </Modal>
  );
}
